import React, { useEffect, useState } from "react";
import Popover from "@material-ui/core/Popover";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DescriptionIcon from "@material-ui/icons/Description";
import { RiVideoFill, RiPagesFill, RiFileEditFill } from "react-icons/ri";
import MicIcon from "@material-ui/icons/Mic";
import { BsImageFill } from "react-icons/bs";
import { HiArchive } from "react-icons/hi";
import { SiGoogleforms } from "react-icons/si"; 
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { contentTypes, elementTypes, learningNodeTypes, evaluationTypes } from "./NodeTypes";
import ContentModal from "./ContentModal";
import PreloaderBlur from "../PreloaderBlur";
import {
  addNewContent,
  createLearningNode,
  getMenuData,
  postLearningEvaluations,
  putLearningConfiguration,
} from "../../../services/NexiDigitalAPI";
import NodeModal from "./NodeModal";
import { CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router";
import BannerCampaignModal from "./BannerCampaignModal";
import CustomTooltip from "components/CustomTooltip";
import flow from "../../../assets/images/flow.svg";
import page from "../../../assets/images/page.svg";
import externalLink from "../../../assets/images/external-link.svg"
import { useNodesTree } from "containers/PeopleCraft/LearningManagementNew/Components/NodesTree/hooks/useNodesTree";

export default function ContentOptionsPopover({
  addContentNode,
  disabled,
  linkContentToBlock,
  setSelectedContentType,
  baseNodeLevel,
  blockData,
  nodeData,
  redirectWithPreChosed
}) {
  const nodeType = nodeData?.nodeType;
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [contentModalVisible, setContentModalVisible] = useState(false);
  const [nodeModalVisible, setNodeModalVisible] = useState(false);
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [currentContentNode, setCurrentContentNode] = useState(null);
  const [idContentItem, setIdContentItem] = useState(null);
  const [loadingNewContent, setLoadingNewContent] = useState(false);
  const [statusCreateLE, setCreateLearningEvaluations] = useState(false);
  const [loadingNodeCreate, setLoadingNodeCreate] = useState(false);
  const { nodeCurrent } = useNodesTree();
  const nodeCode = nodeCurrent.nodeCode || nodeCurrent.originalNodeCode;
  // const { nodeCode } = useParams();

  const handleClick = (event) => {
    if(!!redirectWithPreChosed){
      createEvaluation(blockData, redirectWithPreChosed);
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const contentOptionStyle = {
    fontSize: 35,
    padding: 5,
  };

  const contentOptionKEItemStyle = {
    fontSize: 35,
    padding: 5,
  };

  const getLMSIdContentGroup = () => {
    const contentGroups = JSON.parse(localStorage.getItem("contentGroups"));
    const idCompany = getMenuData()?.idCompany;
    const LMSContentGroup = contentGroups.find(
      (item) => item.idCompany === idCompany && item.context === "LMS",
    ); // TODO alterar name para context
    if (!LMSContentGroup) console.log("ERROR: LMS idContentGroup não encontrado!");
    return LMSContentGroup?.idContentGroup;
  };

  const handleNewContent = (contentItem) => {
    addNewContent({
      text: "",
      description: "",
      idContentType: `${contentItem.idContentType}`,
      idContentGroup: `${getLMSIdContentGroup()}`,
    })
      .then((res) => {
        if (res.data.success) {
          const idContent = res.data.idContentItem; 
          setIdContentItem(idContent);
          setContentModalVisible(true);
          handleClose();
        }
      })
      .catch((err) => {
        console.log("Erro ao criar conteúdo", err);
      })
      .finally(() => {
        setLoadingNewContent(false);
      });
  };

  const allContentOptions = [ 
    {
      title: "Artigo",
      type: contentTypes.ARTICLE,
      className: {},
      icon: <DescriptionIcon style={contentOptionStyle} />,
      idContentType: 5,
      elementType: elementTypes.CONTENT,
    },
    {
      title: "Vídeo",
      type: contentTypes.VIDEO,
      className: {},
      icon: <RiVideoFill style={contentOptionStyle} />,
      idContentType: 2,
      elementType: elementTypes.CONTENT,
    },
    {
      title: "Áudio",
      type: contentTypes.AUDIO,
      className: {},
      icon: <MicIcon style={contentOptionStyle} />,
      idContentType: 1,
      elementType: elementTypes.CONTENT,
    },
    {
      title: "Link externo",
      type: contentTypes.EXTERNAL_LINK,
      className: {},
      icon: (
        <img src={externalLink} style={{...contentOptionStyle, padding: 1}} className="content-option-image" alt="link" />
      ),
      idContentType: 27,
      elementType: elementTypes.CONTENT,
    },
    {
      title: "Avaliação de conhecimento",
      type: contentTypes.KNOWLEDGE_ASSESMENT,
      className: "KEItem",
      icon: <RiFileEditFill style={contentOptionKEItemStyle} />,
      idContentType: 0,
      elementType: elementTypes.REDIRECT,
      evaluationTypes: evaluationTypes.KNOWLEDGE,
    },
    {
      title: "Avaliação de reação",
      type: contentTypes.REACTION_ASSESMENT,
      className: "KEItem",
      icon: <SiGoogleforms style={contentOptionKEItemStyle} />,
      idContentType: 0,
      elementType: elementTypes.REDIRECT,
      evaluationTypes: evaluationTypes.REACTION,
    },
    {
      title: "Pacote Html",
      type: contentTypes.HTML_PACKAGE,
      className: {},
      icon: <RiPagesFill style={contentOptionStyle} />,
      idContentType: 4,
      elementType: elementTypes.CONTENT,
    },
    {
      title: "Arquivo",
      type: contentTypes.FILE,
      className: {},
      icon: <AttachFileIcon style={contentOptionStyle} />,
      idContentType: 18,
      elementType: elementTypes.CONTENT,
    },
    {
      title: "SCORM",
      type: contentTypes.SCORM,
      className: {},
      icon: <HiArchive style={contentOptionStyle} />,
      idContentType: 26,
      elementType: elementTypes.CONTENT,
    },
    {
      title: "Nova página de navegação",
      type: contentTypes.NEW_PAGE_NAVIGATION,
      className: {},
      icon: (
        <img src={flow} style={contentOptionStyle} className="content-option-image" alt="flow" />
      ),
      elementType: elementTypes.NODE,
      nodeType: learningNodeTypes.ORGANIZATION,
    },
    {
      title: "Nova página de aprendizagem",
      type: contentTypes.NEW_PAGE,
      className: {},
      icon: (
        <img src={page} style={contentOptionStyle} className="content-option-image" alt="page" />
      ),
      elementType: elementTypes.NODE,
      nodeType: learningNodeTypes.LEARNING,
    },
    {
      title: "Imagem",
      type: contentTypes.NEW_BANNER_IMAGE,
      className: {},
      icon: <BsImageFill style={contentOptionStyle} />,
      elementType: elementTypes.BANNER_IMAGE,
    },
  ];

  const nodeTypeOrganization =
    blockData.blockType === "MasterBanner"
      ? [ 
          contentTypes.ARTICLE,
          contentTypes.HTML_PACKAGE,
          contentTypes.VIDEO,
          contentTypes.AUDIO,
          contentTypes.EXTERNAL_LINK,
          contentTypes.FILE,
          contentTypes.NEW_PAGE_NAVIGATION,
          contentTypes.NEW_PAGE,
          contentTypes.NEW_BANNER_IMAGE,
        ]
      : [
          contentTypes.ARTICLE,
          contentTypes.HTML_PACKAGE,
          contentTypes.VIDEO,
          contentTypes.AUDIO,
          contentTypes.EXTERNAL_LINK,
          contentTypes.FILE,
          contentTypes.NEW_PAGE_NAVIGATION,
          contentTypes.NEW_PAGE,
        ];

  const nodeTypeLearning =
    blockData.blockType === "MasterBanner"
      ? [ 
          contentTypes.SCORM,
          contentTypes.ARTICLE,
          contentTypes.HTML_PACKAGE,
          contentTypes.VIDEO,
          contentTypes.AUDIO,
          contentTypes.EXTERNAL_LINK,
          contentTypes.FILE,
          contentTypes.NEW_PAGE,
          // contentTypes.NEW_PAGE_NAVIGATION,
          contentTypes.KNOWLEDGE_ASSESMENT,
          contentTypes.REACTION_ASSESMENT,
          contentTypes.NEW_BANNER_IMAGE,
        ]
      : [ 
          contentTypes.SCORM,
          contentTypes.ARTICLE,
          contentTypes.HTML_PACKAGE,
          contentTypes.VIDEO,
          contentTypes.AUDIO,
          contentTypes.EXTERNAL_LINK,
          contentTypes.FILE,
          contentTypes.NEW_PAGE,
          // contentTypes.NEW_PAGE_NAVIGATION,
          contentTypes.KNOWLEDGE_ASSESMENT,
          contentTypes.REACTION_ASSESMENT,
        ];

  const filterOptions = (mustContain) => {
    const newOptions = mustContain.map((item) => {
      const findOption = allContentOptions.find((option) => option.type === item);
      return findOption;
    });

    return newOptions;
  };

  const contentOptions = () => {
    if (nodeType === "ORGANIZATION") {
      return filterOptions(nodeTypeOrganization);
    }
    if (nodeType === "LEARNING") {
      return filterOptions(nodeTypeLearning);
    }
    return allContentOptions;
  };

  const handleNewNode = async (selectedNodeType) => {
    const nodeLevel = parseInt(nodeData.nodeLevel) + 1;
    setLoadingNodeCreate(selectedNodeType);
    // const res = await getNodeLevels(nodeData.nodeCode);
    // const nodeLevels = res.data.nodeLevels;
    // nodeLevels.filter((obj) => obj.nodeLevel == nodeLevel)[0].name
    createLearningNode({
      title: "Título",
      shortTitle: "Título curto",
      company: {
        id: getMenuData().idCompany,
      },
      nodeLevel,
      label: null,
      status: "DRAFT",
      entryPoint: selectedNodeType === "LEARNING" ? true : false,
      essential: selectedNodeType === "LEARNING" ? true : false,
      modality: nodeData.modality,
      tags: [],
      selfEnrollment: nodeData.selfEnrollment,
      parentNodeCode: nodeData.nodeCode,
      attendanceListAsApprovalCriteria: nodeData.attendanceListAsApprovalCriteria
        ? nodeData.attendanceListAsApprovalCriteria
        : false,
      nodeType: selectedNodeType,
      meetings: [],
    })
      .then((res) => {
        const { result } = res.data;
        const valueHideMenuDefault = selectedNodeType === "LEARNING" ? 0 : 1
        putLearningConfiguration({hidMenu: valueHideMenuDefault},result.nodeCode);


        linkContentToBlock(result, "NODE");
      })
      .catch((err) => {
        console.log("ERROR", err);
      })
      .finally(() => {
        setLoadingNodeCreate(false);
      });
  };

  // const createknowledgeEvaluation = (blockData) => {
  //   setCreateLearningEvaluations(true);

  //   const KEData = {
  //     idCompany: getMenuData()?.idCompany,
  //     idEvaluationType: "2", /// identificador do evaluation de conhecimento
  //     evaluationParameters: [],
  //     evaluationTags: [],
  //     categories: [
  //       {
  //         nodeCode: nodeCode,
  //       },
  //     ],
  //   };

  //   postLearningEvaluations(KEData)
  //     .then((res) => {
  //       const idEvaluation = res.data.idEvaluation;

  //       setTimeout(() => {
  //         history.push(`/knowledge-evaluation/${nodeCode}/${blockData?.idBlock}/${idEvaluation}/0`);
  //         setCreateLearningEvaluations(false);
  //       }, 1000 * 1);
  //     })
  //     .catch((err) => {
  //       console.log("Error na criação da avaliação de conhecimento", err.request);
  //       // alert("Error na criação da avaliação de conhecimento");
  //     })
  //     .finally(() => {});
  // };

  const createEvaluation = (blockData, evaluationModel) => {
    setCreateLearningEvaluations(true);

    const KEData = {
      idCompany: getMenuData()?.idCompany,
      idEvaluationType: evaluationModel["indice"], /// identificador do evaluation de conhecimento
      evaluationParameters: [],
      evaluationTags: [],
      categories: [
        {
          nodeCode: nodeCode,
        },
      ],
    };

    postLearningEvaluations(KEData)
      .then((res) => {
        const idEvaluation = res.data.idEvaluation;

        setTimeout(() => {
          history.push(`/${evaluationModel["url"]}/${blockData?.idBlock}/${idEvaluation}/`);
          setCreateLearningEvaluations(false);
        }, 1000 * 1);
      })
      .catch((err) => {
        console.log("Error na criação da avaliação de conhecimento", err.request);
        // alert("Error na criação da avaliação de conhecimento");
      })
      .finally(() => {});
  };

  return (
    <div>
      {statusCreateLE && <PreloaderBlur />}
      {contentModalVisible && (
        <ContentModal
          title="Criação de conteúdo"
          denyAction={() => setContentModalVisible(false)}
          idContentItem={idContentItem}
          returnContentData={(contentData) => {
            linkContentToBlock(contentData);
            setContentModalVisible(false);
          }}
        />
      )}
      {nodeModalVisible && (
        <NodeModal
          title="Criação de Nós"
          denyAction={() => setNodeModalVisible(false)}
          // denyAction={() => setContentModalVisible(false)}
          // idContentItem={idContentItem}
          returnNodeData={(nodeData) => {
            linkContentToBlock(nodeData);
            setNodeModalVisible(false);
          }}
        />
      )}
      {imageModalVisible && (
        <BannerCampaignModal
          title=""
          denyAction={() => setImageModalVisible(false)}
          returnNodeData={(nodeData) => {
            linkContentToBlock(nodeData);
            setImageModalVisible(false);
          }}
        />
      )}
      {disabled ? (
        <AddCircleOutlineIcon
          style={{
            fontSize: 40,
            marginBottom: 5,
            pointerEvents: "none",
            color: "gray",
          }}
        />
      ) : (
        <AddCircleOutlineIcon
          className="content-options-add"
          aria-describedby={id}
          variant="contained"
          color="primary"
          onClick={handleClick}
          style={{ fontSize: 40 }}
        />
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <div className="content-options-container-v2">
          {contentOptions().map((contentItem, index) =>
            contentItem.elementType === elementTypes.NODE && baseNodeLevel >= nodeData.lastNodeLevel ? null : (
              <CustomTooltip
                title={contentItem.title}
                key={`content-options-${index}`}
                className={`node-options-item-v2`}
                style={{ pointerEvents: loadingNewContent ? "none" : "auto" }}
                onClick={() => {
                  if (contentItem.elementType === elementTypes.CONTENT) {
                    setLoadingNewContent(contentItem.type);
                    handleNewContent(contentItem);
                  } else if (contentItem.elementType === elementTypes.REDIRECT) {
                    // createknowledgeEvaluation(blockData);
                    createEvaluation(blockData, contentItem.evaluationTypes);
                  } else if (contentItem.elementType === elementTypes.NODE) {
                    // setNodeModalVisible(true);
                    handleNewNode(contentItem.nodeType);
                  } else if (contentItem.elementType === elementTypes.BANNER_IMAGE) {
                    setImageModalVisible(true);
                    handleClose();
                  }
                  setCurrentContentNode(contentItem);
                  setSelectedContentType(contentItem.type);
                }}
              >
                <div>
                  {contentItem.type === loadingNewContent ||
                  contentItem.nodeType === loadingNodeCreate ? (
                    <CircularProgress size={25} style={{ padding: 3, color: "#6d6b6b" }} />
                  ) : (
                    contentItem.icon
                  )}
                </div>
              </CustomTooltip>
            ),
          )}
        </div>
      </Popover>
    </div>
  );
}
